import React from 'react';
import { RadioField, Container, FormPanel } from '@sencha/ext-modern';

export default function GroupRadioField(props) {
	const { label, options, onCheck, checked, labelHide, margin, disabled } = props
	return (
		<FormPanel margin={margin} layout={{ type: "vbox", wrap: "true" }} padding={0} bodyStyle={{ backgroundColor: "#ffffff" }}>

			<Container layout={{ type: "hbox", wrap: "true" }} style={{ fontSize: "12px", fontWeight: 'bold' }}>
				{label && !labelHide && <p>{label}</p>}
				{options && options.map((o, index) => {
					return (<RadioField disabled={disabled} name="radios" key={index} boxLabel={o} onCheck={onCheck} value={label} checked={checked === o} padding={label && '0 0 0 15' || '0 15 0 0'} />)
				})}
			</Container>
		</FormPanel>
	)
}